<template>
    <div class="md-layout">
        <div class="md-layout-item md-small-size-100">
            <md-card>
                <md-card-header class="md-card-header-icon md-card-header-green">
                    <div class="card-icon">
                        <md-icon>tag</md-icon>
                    </div>
                    <h4 class="title">Add level</h4>
                </md-card-header>

                <form @submit.prevent="add">
                    <md-card-content>
                        <div class="text-right">
                            <md-button @click="goBack" class="md-primary md-dense">
                                Back to List
                            </md-button>
                        </div>

                        <div class="md-layout">
                            <label class="md-layout-item md-size-25 md-form-label">
                                Name
                            </label>
                            <div class="md-layout-item">
                                <md-field class="md-invalid">
                                    <md-input v-model="level.name" />
                                    <validation-error :errors="apiValidationErrors.name" />
                                </md-field>
                            </div>
                        </div>
                        <div class="md-layout">
                            <label class="md-layout-item md-size-25 md-form-label">
                                Short Name
                            </label>
                            <div class="md-layout-item">
                                <md-field class="md-invalid">
                                    <md-input v-model="level.short_name" />
                                    <validation-error :errors="apiValidationErrors.short_name"  />
                                </md-field>
                            </div>
                        </div>
                        <div class="md-layout spacing">
                            <label class="md-layout-item md-size-25 md-form-label">
                                Description
                            </label>
                            <div class="md-layout-item">
                                <ckeditor
                                        :editor="editor"
                                        v-model="level.description"
                                        :config="editorConfig"
                                ></ckeditor>
                                <validation-error :errors="apiValidationErrors.description" />
                            </div>
                        </div>
                        <div class="md-layout">
                            <label class="md-layout-item md-size-25 md-form-label">
                                Exam ID
                            </label>
                            <div class="md-layout-item">
                                <md-field class="md-invalid">
                                    <md-input v-model="level.exam_id" />
                                    <validation-error :errors="apiValidationErrors.exam_id"  />
                                </md-field>
                            </div>
                        </div>
                        <div class="md-layout spacing">
                            <label class="md-layout-item md-size-25 md-form-label">
                                Level For
                            </label>
                            <div class="md-layout-item">
                                <md-field>
                                    <label>Select ...</label>
                                    <md-select v-model="level.level_for" name="active">
                                        <md-option value="necta">Necta</md-option>
                                        <md-option value="nacte">Nacte</md-option>
                                        <md-option value="tcu">tcu</md-option>
                                        <md-option value="veta">veta</md-option>
                                        <md-option value="tra">tra</md-option>
                                    </md-select>
                                </md-field>
                                <validation-error :errors="apiValidationErrors.level_for" />
                            </div>
                        </div>
                        <div class="md-layout spacing">
                            <label class="md-layout-item md-size-25 md-form-label">
                                Active
                            </label>
                            <div class="md-layout-item">
                                <md-field>
                                    <label>Select ...</label>
                                    <md-select v-model="level.active" name="active">
                                        <md-option value=1>Yes</md-option>
                                        <md-option value=0>No</md-option>
                                    </md-select>
                                </md-field>
                                <validation-error :errors="apiValidationErrors.active" />
                            </div>
                        </div>

                    </md-card-content>

                    <md-card-actions md-alignment="right">
                        <md-button type="submit" class="md-success">Add level</md-button>
                    </md-card-actions>
                </form>
            </md-card>
        </div>
    </div>
</template>
<script>
import { ValidationError } from '@/components';
import formMixin from '@/mixins/form-mixin';
import ClassicEditor from '@ckeditor/ckeditor5-build-classic';
import CKEditor from '@ckeditor/ckeditor5-vue';

export default {
    components: { ValidationError, ckeditor: CKEditor.component },

    mixins: [formMixin],

    data: () => ({
        editor: ClassicEditor,
        editorConfig: {
            toolbar: [
                'heading',
                '|',
                'bold',
                'italic',
                'link',
                'bulletedList',
                'numberedList',
                'blockQuote',
                'Outdent',
                'Indent',
                'TextColor',
                'BGColor',
            ],
        },

        level: {
            type:'levels',
            name:null,
            short_name:null,
            description: null,
            exam_id:null,
            level_for: null,
            active: null,

        },
    }),
    methods: {
        async add () {
            try {
                await this.$store.dispatch('levels/add',  this.level);
                this.notifySuccess('Level added successfully.');
                this.goBack();
            } catch (e) {
                if (e.response.data.errors[0]) {
                    await this.notifyError(e.response.data.errors[0].title);
                    this.setApiValidation(e.response.data.errors);
                } else {
                    await this.notifyError('Oops, something went wrong!');
                }
            }
        },

        goBack () {
            this.$router.push({ name: 'Levels List' });
        },

    },
};
</script>
